module.exports = __webpack_public_path__ + "img/sf_subject.a343669d.png";